import Edit from './edit.vue'
import Show from './show.vue'
export default {
  Show,
  Edit,
  data: {
    data() {
      return {
        data: {
          type: 'goods',
          goodsType: 'goods',
          goodsIds: [],
          category: null,
          listMode: 'small',
          // 每行几个商品，只在小图模式下生效（大图/一大两小/列表的排布是固定的）
          rowCount: 2,
          // 商品标签：文案不填就不显示标签；颜色不填走主题的主色/辅色
          tagText: '',
          tagBgColor: '',
          tagTextColor: '',
          showBuyBtn: 1,
          showPrice: 1,
          showTitle: 1,
          btnStyle: 0
        },
        render: "Goods",
      }
    },
    data2() {
      return {
        data: {
          list: [],
          type: 'category',
          showType: 'top',
          showAll: 0,
          listMode: 'small',
          showBuyBtn: 1,
          showPrice: 1,
          showTitle: 1,
          btnStyle: 0,
          imageGap: 15,
          imageRadius:0 ,
          pageGap: 15,
          // 商品标签：文案不填就不显示标签；颜色不填走主题的主色/辅色
          tagText: '',
          tagBgColor: '',
          tagTextColor: '',
        },
        render: "Goods",
      }
    },
    name: "商品",
    icon: "iconshangpin",
  }
}